// Mock data for Christina Bellaro's portfolio, organized by client
// All images pulled from her existing Crevado portfolio

export const artist = {
  name: "Christina Bellaro",
  title: "Senior Graphic Designer",
  tagline: "Crafting Experiences Through Impactful Design",
  experience: "20 years",
  bio: "Hello there! I'm a Senior Graphic Designer with 20 years of experience in marketing, branding, and creative storytelling \u2014 crafting compelling, high-impact campaigns that consistently exceed client expectations. And I do it all with a fun sense of humor and a smile.",
  email: "tinabellaro@gmail.com",
  location: "Scotch Plains, NJ",
  photo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_work-gallery-307/artifacts/mzw1oso1_profile%20pic.png",
  socials: {
    linkedin: "https://www.linkedin.com/in/christina-bellaro/",
    behance: "https://behance.net/christinabellaro"
  }
};

export const services = [
  "Brand Identity & Guidelines",
  "Art Direction & Creative Strategy",
  "Packaging & Apparel Design",
  "Event Signage & Environmental",
  "Print Collateral & Publications",
  "E-books & Infographics",
  "PowerPoint & Keynote Decks",
  "Digital & Email Campaigns",
  "Digital Campaigns & Paid Advertising",
  "Social Media Graphics",
  "Social Media Management",
  "Website Edits & Administration",
  "Analytics & Performance Reporting",
  "Direct Mail Campaigns"
];

export const specialties = [
  {
    title: "Brand Cohesion & Identity Systems",
    description: "I develop cohesive visual languages across campaigns and product lines — often building templates and style guides that keep teams aligned and brand integrity intact. Skilled at 360° brand design, from foundational identity to every customer touchpoint."
  },
  {
    title: "Presentation & Pitch Design",
    description: "I design clean, executive-level slide decks that simplify complex ideas through custom layouts, infographics, and tightly integrated messaging — built to land in boardrooms, on stages, and inside investor meetings."
  },
  {
    title: "Web & Interactive Projects",
    description: "I've worked on WordPress and HubSpot-driven web assets, translating brand direction into user-friendly digital experiences — landing pages, email systems, and on-brand interactive campaigns."
  }
];

// Additional brand names to display in the home page marquee (no detail pages required)
export const marqueeExtras = [
  "Quadriga Art",
  "OC Transpo",
  "Bank of America",
  "Merrill Lynch",
  "Novo Nordisk",
  "L'Oréal",
  "FedEx",
  "Lenovo",
  "Midea",
  "Abbott",
  "Samsung"
];

// Fortune-class brands she's contributed work for (across agency engagements).
// Displayed as a "Trusted by" section — no detail pages.
export const trustedBy = [
  "Bank of America",
  "Merrill Lynch",
  "Novo Nordisk",
  "L'Oréal",
  "FedEx",
  "Lenovo",
  "Midea",
  "Abbott",
  "Samsung"
];

export const designTools = [
  "Adobe Photoshop",
  "Adobe Illustrator",
  "Adobe InDesign",
  "Adobe XD",
  "Figma",
  "Adobe Express",
  "PowerPoint",
  "WordPress",
  "HubSpot",
  "Framer",
  "SharePoint"
];

export const aiTools = [
  "ChatGPT",
  "Claude",
  "Nano Banana",
  "Adobe Firefly",
  "Midjourney",
  "Grok"
];

export const aiStatement = "I've adopted and embraced AI tools into my daily routine — using them to accelerate ideation, prototype faster, and free up the most valuable thing I have to give a client: judgment, taste, and craft.";

export const clients = [
  {
    slug: "informa-techtarget",
    name: "Informa TechTarget",
    industry: "B2B Tech Media",
    summary: "Complete rebrand collateral rollout \u2014 e-books, infographics, social media cards, and print collateral harmonizing two merged tech-media giants into a unified visual identity.",
    featured: true,
    cover: "https://customer-assets.emergentagent.com/job_work-gallery-307/artifacts/os1xrmxf_699eaa4d-bb0b-4d17-b94d-2a2f460cd231_rw_3840.jpg",
    projects: [
      { id: "it-0", title: "Navigating ABM Engagement in the Age of AI \u2014 E-book", type: "E-book", image: "https://customer-assets.emergentagent.com/job_work-gallery-307/artifacts/os1xrmxf_699eaa4d-bb0b-4d17-b94d-2a2f460cd231_rw_3840.jpg" },
      { id: "it-1", title: "E-book Rebrand", type: "E-book", image: "https://cdn.crevado.com/artists/1062266/artwork/19360534_mobile-1.png" },
      { id: "it-2", title: "E-book Rebrand", type: "E-book", image: "https://cdn.crevado.com/artists/1062266/artwork/19360538_mobile-1.png" },
      { id: "it-3", title: "E-book Rebrand", type: "E-book", image: "https://cdn.crevado.com/artists/1062266/artwork/19611270_mobile-1.jpg" },
      { id: "it-4", title: "Rebrand Collateral Examples", type: "Collateral", image: "https://cdn.crevado.com/artists/1062266/artwork/19360514_mobile-1.jpg" },
      { id: "it-5", title: "E-book Rebrand", type: "E-book", image: "https://cdn.crevado.com/artists/1062266/artwork/19611274_mobile-1.jpg" },
      { id: "it-6", title: "E-book Rebrand", type: "E-book", image: "https://cdn.crevado.com/artists/1062266/artwork/19360518_mobile-1.jpg" },
      { id: "it-7", title: "E-book Rebrand", type: "E-book", image: "https://cdn.crevado.com/artists/1062266/artwork/19360522_mobile-1.jpg" },
      { id: "it-9", title: "Infographic Rebrand", type: "Infographic", image: "https://cdn.crevado.com/artists/1062266/artwork/19360506_mobile-1.jpg", scale: 0.4 },
      { id: "it-10", title: "E-book Rebrand (Print)", type: "Print", image: "https://cdn.crevado.com/artists/1062266/artwork/19519874_mobile-1.jpg" },
      { id: "it-11", title: "E-book Rebrand (Print)", type: "Print", image: "https://cdn.crevado.com/artists/1062266/artwork/19519866_mobile-1.jpg" },
      { id: "it-12", title: "Social Media Card", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/19519934_mobile-1.jpg" },
      { id: "it-13", title: "Social Media Card", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/19519930_mobile-1.jpg" },
      { id: "it-14", title: "Social Media Card", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/19519926_mobile-1.jpg" },
      { id: "it-15", title: "Social Media Card", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/19519918_mobile-1.jpg" },
      { id: "it-16", title: "Social Media Card", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/19519902_mobile-1.jpg" },
      { id: "it-17", title: "Social Media Card", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/19519898_mobile-1.jpg" }
    ]
  },
  {
    slug: "ipc-systems",
    name: "IPC Systems",
    industry: "Financial Tech / Trading",
    summary: "Global product launch campaigns, Nasdaq closing bell ceremony graphics, trader networking events across NYC, Hong Kong, and Singapore. Signage, social, and infographics.",
    featured: true,
    cover: "https://cdn.crevado.com/artists/1062266/artwork/19394394_mobile.jpg",
    projects: [
      { id: "ipc-1", title: "Nasdaq Closing Bell Ceremony Tower Graphics", type: "Signage", image: "https://cdn.crevado.com/artists/1062266/artwork/19394394_mobile.jpg" },
      { id: "ipc-2", title: "Nasdaq Tower Graphics", type: "Signage", image: "https://cdn.crevado.com/artists/1062266/artwork/19394434_mobile-2.jpg" },
      { id: "ipc-3", title: "Nasdaq Tower Graphics", type: "Signage", image: "https://cdn.crevado.com/artists/1062266/artwork/19394438_mobile-2.jpg" },
      { id: "ipc-4", title: "Nasdaq Tower Graphics", type: "Signage", image: "https://cdn.crevado.com/artists/1062266/artwork/19394442_mobile-2.jpg" },
      { id: "ipc-5", title: "Nasdaq Tower Graphics", type: "Signage", image: "https://cdn.crevado.com/artists/1062266/artwork/19394446_mobile-2.jpg" },
      { id: "ipc-6", title: "Nasdaq Tower Graphics", type: "Signage", image: "https://cdn.crevado.com/artists/1062266/artwork/19394454_mobile-2.jpg" },
      { id: "ipc-7", title: "Nasdaq Tower Graphics", type: "Signage", image: "https://cdn.crevado.com/artists/1062266/artwork/19394458_mobile-2.jpg" },
      { id: "ipc-8", title: "Rainbow Room NYC \u2014 Private Product Launch", type: "Event", image: "https://cdn.crevado.com/artists/1062266/artwork/16980146_mobile-1.jpg" },
      { id: "ipc-9", title: "Rainbow Room Private Product Launch", type: "Event", image: "https://cdn.crevado.com/artists/1062266/artwork/16980158_mobile-1.jpg" },
      { id: "ipc-11", title: "Rainbow Room Private Product Launch", type: "Event", image: "https://cdn.crevado.com/artists/1062266/artwork/16980154_mobile-1.jpg" },
      { id: "ipc-12", title: "Banner Sign at Networking Event", type: "Signage", image: "https://cdn.crevado.com/artists/1062266/artwork/16980202_mobile-1.jpg" },
      { id: "ipc-13", title: "Table Tent Card \u2014 Hong Kong Product Launch", type: "Print", image: "https://cdn.crevado.com/artists/1062266/artwork/16980210_mobile-1.jpg" },
      { id: "ipc-14", title: "National Sales KickOff Banner", type: "Signage", image: "https://cdn.crevado.com/artists/1062266/artwork/16980174_mobile-1.jpg" },
      { id: "ipc-15", title: "Product Launch \u2014 Singapore", type: "Event", image: "https://cdn.crevado.com/artists/1062266/artwork/16883506_mobile-1.jpg" },
      { id: "ipc-16", title: "National Sales KickOff Banner", type: "Signage", image: "https://cdn.crevado.com/artists/1062266/artwork/16980178_mobile-1.jpg" },
      { id: "ipc-17", title: "Product Launch \u2014 Artemis Club, Singapore", type: "Event", image: "https://cdn.crevado.com/artists/1062266/artwork/16883714_mobile-1.jpg" },
      { id: "ipc-18", title: "Trader Networking Event Banner", type: "Signage", image: "https://cdn.crevado.com/artists/1062266/artwork/16883498_mobile-1.jpg" },
      { id: "ipc-19", title: "Trader Networking Event Banner", type: "Signage", image: "https://cdn.crevado.com/artists/1062266/artwork/16883510_mobile-1.jpg" },
      { id: "ipc-20", title: "Infographic", type: "Infographic", image: "https://cdn.crevado.com/artists/1062266/artwork/19360510_mobile-1.jpg", scale: 0.5 },
      { id: "ipc-21", title: "Infographic", type: "Infographic", image: "https://cdn.crevado.com/artists/1062266/artwork/19360502_mobile-1.jpg", scale: 0.4 },
      { id: "ipc-22", title: "National Sales KickOff 2020", type: "Presentation", image: "https://cdn.crevado.com/artists/1062266/artwork/16980182_mobile-1.jpg" },
      { id: "ipc-23", title: "Rainbow Room NYC Product Launch Deck", type: "Presentation", image: "https://cdn.crevado.com/artists/1062266/artwork/16980270_mobile-1.jpg" },
      { id: "ipc-24", title: "LinkedIn Post \u2014 Webinar", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/18193242_mobile-1.jpg" },
      { id: "ipc-25", title: "LinkedIn Post \u2014 Product Launch", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/18199174_mobile-1.jpg" },
      { id: "ipc-26", title: "LinkedIn Post", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/16883566_mobile-1.jpg" },
      { id: "ipc-27", title: "LinkedIn Post", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/16883570_mobile-1.jpg" },
      { id: "ipc-28", title: "French LinkedIn Post", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/16883578_mobile-1.jpg" },
      { id: "ipc-29", title: "LinkedIn Post", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/16883554_mobile-1.jpg" },
      { id: "ipc-30", title: "LinkedIn Post", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/16883606_mobile-1.jpg" },
      { id: "ipc-31", title: "LinkedIn Post", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/16883610_mobile-1.jpg" },
      { id: "ipc-32", title: "LinkedIn Post", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/16883594_mobile-1.jpg" },
      { id: "ipc-33", title: "LinkedIn Post", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/16883590_mobile-1.jpg" },
      { id: "ipc-34", title: "LinkedIn Post", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/16883602_mobile-1.jpg" },
      { id: "ipc-37", title: "LinkedIn Paid Ad Carousel", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/16883442_mobile-1.jpg" }
    ]
  },
  {
    slug: "harte-hanks",
    name: "Harte Hanks",
    industry: "Marketing Services",
    summary: "Enterprise creative for Fortune 500 clients \u2014 SalonCentric/L'Or\u00e9al beauty boxes, PGA event swag, Siemens posters, brand guidelines, and Playbook campaigns.",
    featured: true,
    cover: "https://cdn.crevado.com/artists/1062266/artwork/19360454_mobile-1.jpg",
    projects: [
      { id: "hh-1", title: "SalonCentric / L'Or\u00e9al Beauty Box", type: "Packaging", image: "https://cdn.crevado.com/artists/1062266/artwork/19360454_mobile-1.jpg" },
      { id: "hh-2", title: "PGA Event Swag Box", type: "Packaging", image: "https://cdn.crevado.com/artists/1062266/artwork/19360458_mobile-1.jpg" },
      { id: "hh-3", title: "Siemens Poster", type: "Print", image: "https://cdn.crevado.com/artists/1062266/artwork/19361750_mobile-1.png" },
      { id: "hh-4", title: "Trade Show PowerPoint \u2014 Europe", type: "Presentation", image: "https://cdn.crevado.com/artists/1062266/artwork/16980214_mobile-1.jpg" },
      { id: "hh-5", title: "Various PowerPoint Slides", type: "Presentation", image: "https://cdn.crevado.com/artists/1062266/artwork/19361746_mobile-1.png" },
      { id: "hh-6", title: "Isometric Icon Design \u2014 PPT & Web", type: "Illustration", image: "https://cdn.crevado.com/artists/1062266/artwork/19611150_mobile-1.png" },
      { id: "hh-7", title: "Brand Style Guidelines Document", type: "Brand", image: "https://cdn.crevado.com/artists/1062266/artwork/16952934_mobile-1.jpg" },
      { id: "hh-8", title: "PowerPoint Slide Design Skills", type: "Presentation", image: "https://cdn.crevado.com/artists/1062266/artwork/18926678_mobile-1.jpg" },
      { id: "hh-9", title: "PowerPoint Sample Slides", type: "Presentation", image: "https://cdn.crevado.com/artists/1062266/artwork/18093110_mobile-1.jpg" },
      { id: "hh-10", title: "Digital Ad \u2014 Playbook", type: "Digital", image: "https://cdn.crevado.com/artists/1062266/artwork/18193214_mobile-1.jpg" },
      { id: "hh-11", title: "Digital Ad \u2014 Playbook", type: "Digital", image: "https://cdn.crevado.com/artists/1062266/artwork/18193218_mobile-1.jpg" },
      { id: "hh-14", title: "PowerPoint Slide Design Examples", type: "Presentation", image: "https://cdn.crevado.com/artists/1062266/artwork/18926050_mobile-1.jpg" },
      { id: "hh-15", title: "PGA Buying & Education Summit \u2014 Swag Gift Box", type: "Packaging", image: "https://customer-assets.emergentagent.com/job_work-gallery-307/artifacts/zkirajwg_3003db2f-c1f3-4a62-bbfc-db2afeab57da_rw_1200.jpg" },
      { id: "hh-16", title: "LinkedIn Promoted Ads \u2014 Logistics Campaign", type: "Social", image: "https://customer-assets.emergentagent.com/job_work-gallery-307/artifacts/o0yuqusa_0fcd6158-6ba2-4eb8-99bb-b63a2b4fd77b_rw_1200.jpg" },
      { id: "hh-17", title: "Who's Driving Your Marketing? \u2014 One-Pager", type: "Print", image: "https://customer-assets.emergentagent.com/job_work-gallery-307/artifacts/hpx8al8w_1f6f9e22-d03f-4221-a01a-7911a85d88c1_rw_1920.jpg" },
      { id: "hh-18", title: "7 Reasons Why Blogging Could Be Good \u2014 LinkedIn Carousel", type: "Social", image: "https://customer-assets.emergentagent.com/job_work-gallery-307/artifacts/495wzmp6_2cc337fe-a770-4dd3-a502-24807e9eb5bf_rw_1920.jpg" },
      { id: "hh-19", title: "Take Your Business to the Next Level \u2014 Services Infographic", type: "Infographic", image: "https://customer-assets.emergentagent.com/job_work-gallery-307/artifacts/bot4tw0y_54704597-2a9d-4db3-95c0-a75e85e1b3c0_rw_1920.jpg" },
      { id: "hh-20", title: "LinkedIn Post", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/16883446_mobile-1.jpg" },
      { id: "hh-21", title: "Paid Ads (LinkedIn)", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/16883454_mobile-1.jpg" }
    ]
  },
  {
    slug: "gurobi-optimization",
    name: "Gurobi Optimization",
    industry: "Decision Intelligence SaaS",
    summary: "Event branding for Gurobi Summit Americas (Las Vegas) and Amsterdam \u2014 complete deliverables from agenda to signage to social.",
    featured: true,
    cover: "https://cdn.crevado.com/artists/1062266/artwork/19382474_mobile-1.png",
    projects: [
      { id: "gu-1", title: "Gurobi Summit Americas 2024 \u2014 All Deliverables", type: "Event", image: "https://cdn.crevado.com/artists/1062266/artwork/18073974_mobile-1.png" },
      { id: "gu-2", title: "Event Signage", type: "Signage", image: "https://cdn.crevado.com/artists/1062266/artwork/19382474_mobile-1.png" },
      { id: "gu-3", title: "Summit Event Signage \u2014 Las Vegas & Amsterdam", type: "Signage", image: "https://cdn.crevado.com/artists/1062266/artwork/19361722_mobile-1.png" },
      { id: "gu-4", title: "Summit Event Signage \u2014 Las Vegas & Amsterdam", type: "Signage", image: "https://cdn.crevado.com/artists/1062266/artwork/19360466_mobile-1.jpg" },
      { id: "gu-5", title: "Decision Intelligence Summit Agenda", type: "Print", image: "https://cdn.crevado.com/artists/1062266/artwork/19519842_mobile-1.png" },
      { id: "gu-6", title: "Decision Intelligence Summit Agenda", type: "Print", image: "https://cdn.crevado.com/artists/1062266/artwork/19509922_mobile-1.png" },
      { id: "gu-7", title: "Social Media Post", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/19382478_mobile-1.jpg" },
      { id: "gu-8", title: "Social Media Posts", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/18152282_mobile-1.jpg" },
      { id: "gu-9", title: "Carousel Design", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/18441074_mobile-1.jpg" }
    ]
  },
  {
    slug: "bang-energy",
    name: "Bang Energy",
    industry: "Beverage / CPG",
    summary: "High-octane packaging design, apparel, and promotional posters for the iconic energy drink brand.",
    featured: true,
    cover: "https://cdn.crevado.com/artists/1062266/artwork/19360462_mobile-1.jpg",
    projects: [
      { id: "ba-1", title: "Bang Energy Packaging Design", type: "Packaging", image: "https://cdn.crevado.com/artists/1062266/artwork/19360462_mobile-1.jpg" },
      { id: "ba-2", title: "Bang Energy T-Shirt", type: "Apparel", image: "https://cdn.crevado.com/artists/1062266/artwork/19382586_mobile-1.png" },
      { id: "ba-3", title: "Bang Energy Hoodie", type: "Apparel", image: "https://cdn.crevado.com/artists/1062266/artwork/19382594_mobile-1.png" },
      { id: "ba-4", title: "Bang Energy Poster", type: "Print", image: "https://cdn.crevado.com/artists/1062266/artwork/19360438_mobile-1.jpg" },
      { id: "ba-5", title: "Bang Energy Poster", type: "Print", image: "https://cdn.crevado.com/artists/1062266/artwork/19519854_mobile-1.jpg" }
    ]
  },
  {
    slug: "urban-coffee",
    name: "Urban Coffee",
    industry: "Food & Beverage",
    summary: "Warm, artisan-forward branding for a neighborhood coffee roaster \u2014 storefront signage, packaging, and branded merchandise.",
    featured: true,
    cover: "https://customer-assets.emergentagent.com/job_work-gallery-307/artifacts/rcrfkees_Urban%20Coffee%20Ship%20Signage.jpg",
    projects: [
      { id: "uc-0", title: "Storefront Signage & Window Graphics", type: "Signage", image: "https://customer-assets.emergentagent.com/job_work-gallery-307/artifacts/rcrfkees_Urban%20Coffee%20Ship%20Signage.jpg" },
      { id: "uc-1", title: "Coffee Bag", type: "Packaging", image: "https://cdn.crevado.com/artists/1062266/artwork/19360442_mobile-1.jpg" },
      { id: "uc-2", title: "Employee Apron", type: "Apparel", image: "https://cdn.crevado.com/artists/1062266/artwork/19382530_mobile-1.png" },
      { id: "uc-3", title: "Tote Bag", type: "Merch", image: "https://cdn.crevado.com/artists/1062266/artwork/19382534_mobile-1.png" }
    ]
  },
  {
    slug: "quadriga-art",
    name: "Quadriga Art",
    industry: "Non-Profit Fundraising",
    summary: "International charity direct-mail campaigns across French, Italian, German, and Dutch markets \u2014 envelope mailers, greeting cards, and premium box sets.",
    featured: false,
    cover: "https://cdn.crevado.com/artists/1062266/artwork/19501562_mobile-1.jpg",
    projects: [
      { id: "qa-1", title: "CARE Non-Profit Charity Envelope Mailer", type: "Direct Mail", image: "https://cdn.crevado.com/artists/1062266/artwork/19501562_mobile-1.jpg" },
      { id: "qa-2", title: "DUTCH Envelope Mailer", type: "Direct Mail", image: "https://cdn.crevado.com/artists/1062266/artwork/19501566_mobile-1.jpg" },
      { id: "qa-3", title: "FRENCH Box Mailer with Premiums", type: "Direct Mail", image: "https://cdn.crevado.com/artists/1062266/artwork/19501574_mobile-1.jpg" },
      { id: "qa-4", title: "ITALIAN Charity Envelope Mailer", type: "Direct Mail", image: "https://cdn.crevado.com/artists/1062266/artwork/19501582_mobile-1.jpg" },
      { id: "qa-5", title: "GERMAN Christmas Greeting Card Mailer", type: "Direct Mail", image: "https://cdn.crevado.com/artists/1062266/artwork/19501590_mobile-1.jpg" },
      { id: "qa-6", title: "Charity Mailer Detail", type: "Direct Mail", image: "https://cdn.crevado.com/artists/1062266/artwork/19501554_mobile-1.jpg" },
      { id: "qa-7", title: "Charity Mailer Detail", type: "Direct Mail", image: "https://cdn.crevado.com/artists/1062266/artwork/19501558_mobile-1.jpg" },
      { id: "qa-8", title: "Charity Mailer Detail", type: "Direct Mail", image: "https://cdn.crevado.com/artists/1062266/artwork/19501570_mobile-1.jpg" },
      { id: "qa-9", title: "Charity Mailer Detail", type: "Direct Mail", image: "https://cdn.crevado.com/artists/1062266/artwork/19501578_mobile-1.jpg" },
      { id: "qa-10", title: "Charity Mailer Detail", type: "Direct Mail", image: "https://cdn.crevado.com/artists/1062266/artwork/19501586_mobile-1.jpg" }
    ]
  },
  {
    slug: "kika-stretch-studios",
    name: "Kika Stretch Studios",
    industry: "Wellness / The Kika Method®",
    summary: "Full-spectrum brand and marketing design for the home of The Kika Method® \u2014 storefront signage, in-studio environmental graphics, app-driven promotional campaigns, educational infographics, and franchise-ready advertising for Power Stretch Studios.",
    featured: true,
    cover: "https://customer-assets.emergentagent.com/job_work-gallery-307/artifacts/so42vofv_874c199f-33d7-49b4-9f01-6916f114706e_rw_1200.jpg",
    projects: [
      { id: "kk-0", title: "Power Stretch Studios \u2014 Home of The Kika Method (Print Ad)", type: "Print", image: "https://customer-assets.emergentagent.com/job_work-gallery-307/artifacts/so42vofv_874c199f-33d7-49b4-9f01-6916f114706e_rw_1200.jpg" },
      { id: "kk-1", title: "Logo Design & Wall Decal", type: "Brand", image: "https://cdn.crevado.com/artists/1062266/artwork/18211274_mobile-1.jpg" },
      { id: "kk-2", title: "Sandwich Board Sign", type: "Signage", image: "https://cdn.crevado.com/artists/1062266/artwork/16883502_mobile-1.jpg" },
      { id: "kk-3", title: "Digital Ad", type: "Digital", image: "https://cdn.crevado.com/artists/1062266/artwork/18211286_mobile-1.jpg" },
      { id: "kk-4", title: "Holiday Social Media Post", type: "Social", image: "https://cdn.crevado.com/artists/1062266/artwork/18211278_mobile-1.jpg" },
      { id: "kk-5", title: "New Client Special \u2014 App Promo Ad", type: "Digital", image: "https://customer-assets.emergentagent.com/job_work-gallery-307/artifacts/5xqjor3c_465174870_27444677261844045_1296967848967796474_n.jpg" },
      { id: "kk-6", title: "15% Off First Package \u2014 Promotional Coupons", type: "Print", image: "https://customer-assets.emergentagent.com/job_work-gallery-307/artifacts/4pjwkrnk_465281224_27466693606309077_439721478453577152_n.jpg" },
      { id: "kk-7", title: "What is Your Kika Stretch Age? \u2014 In-Studio Poster", type: "Signage", image: "https://customer-assets.emergentagent.com/job_work-gallery-307/artifacts/erkrx832_465182598_27453866730925098_5052728123594076322_n.jpg" },
      { id: "kk-8", title: "The Kika Method vs. Other Therapies \u2014 Educational Infographic", type: "Infographic", image: "https://customer-assets.emergentagent.com/job_work-gallery-307/artifacts/sss8npdd_465176283_27436467989331639_923250467181040173_n.jpg" }
    ]
  },
  {
    slug: "copper-hill",
    name: "Copper Hill Strength & Wellness",
    industry: "Fitness",
    summary: "Full website design for a strength and wellness studio with a warm, community-forward vibe.",
    featured: false,
    cover: "https://cdn.crevado.com/artists/1062266/artwork/19361934_mobile-1.png",
    projects: [
      { id: "ch-1", title: "Website Homepage Design", type: "Web", image: "https://cdn.crevado.com/artists/1062266/artwork/19361934_mobile-1.png" },
      { id: "ch-2", title: "Website Design", type: "Web", image: "https://cdn.crevado.com/artists/1062266/artwork/19519878_mobile-1.jpg" }
    ]
  },
  {
    slug: "godiva",
    name: "Godiva Chocolatier",
    industry: "Luxury Retail / Chocolate",
    summary: "In-store retail poster design for the iconic luxury chocolatier.",
    featured: false,
    cover: "https://cdn.crevado.com/artists/1062266/artwork/19519862_original-1.jpg",
    projects: [
      { id: "gd-1", title: "Godiva Retail Store Poster", type: "Print", image: "https://cdn.crevado.com/artists/1062266/artwork/19519862_original-1.jpg" },
      { id: "gd-2", title: "Mother's Day Campaign \u2014 French Market", type: "Print", image: "https://customer-assets.emergentagent.com/job_work-gallery-307/artifacts/uaxqf3ho_4335ab7f-6815-4070-8461-19c90adf3ab9_rw_600.jpg" }
    ]
  },
  {
    slug: "personal-custom",
    name: "Personal & Custom Work",
    industry: "Custom Commissions",
    summary: "Bespoke personal design commissions \u2014 birth announcements, invitations, custom apparel, art-gallery event invites, and small-business branding.",
    featured: false,
    cover: "https://cdn.crevado.com/artists/1062266/artwork/19360474_mobile-1.jpg",
    projects: [
      { id: "pc-1", title: "Custom Birth Announcement Design", type: "Custom", image: "https://cdn.crevado.com/artists/1062266/artwork/19360474_mobile-1.jpg" },
      { id: "pc-2", title: "Custom T-Shirt Design", type: "Apparel", image: "https://cdn.crevado.com/artists/1062266/artwork/19382542_mobile-1.jpg" },
      { id: "pc-3", title: "Art Gallery Private Event Invitation", type: "Digital", image: "https://cdn.crevado.com/artists/1062266/artwork/19382410_mobile-1.jpg" },
      { id: "pc-4", title: "Beauty Email Campaign", type: "Digital", image: "https://cdn.crevado.com/artists/1062266/artwork/19361918_mobile-1.png" },
      { id: "pc-5", title: "Perfume Subscription Box", type: "Packaging", image: "https://cdn.crevado.com/artists/1062266/artwork/19519858_mobile-1.jpg" },
      { id: "pc-6", title: "Custom Design", type: "Custom", image: "https://cdn.crevado.com/artists/1062266/artwork/19382538_mobile-1.jpg" },
      { id: "pc-7", title: "Custom Design", type: "Custom", image: "https://cdn.crevado.com/artists/1062266/artwork/19360478_mobile-1.jpg" },
      { id: "pc-8", title: "Custom Design", type: "Custom", image: "https://cdn.crevado.com/artists/1062266/artwork/19360486_mobile-1.jpg" },
      { id: "pc-9", title: "Custom Design", type: "Custom", image: "https://cdn.crevado.com/artists/1062266/artwork/19360498_mobile-1.jpg" },
      { id: "pc-10", title: "Custom Design", type: "Custom", image: "https://cdn.crevado.com/artists/1062266/artwork/19360490_mobile-1.jpg" },
      { id: "pc-11", title: "Custom Design", type: "Custom", image: "https://cdn.crevado.com/artists/1062266/artwork/19361786_mobile-1.png" },
      { id: "pc-12", title: "Custom Design", type: "Custom", image: "https://cdn.crevado.com/artists/1062266/artwork/19361790_mobile-1.png" },
      { id: "pc-13", title: "Custom Design", type: "Custom", image: "https://cdn.crevado.com/artists/1062266/artwork/19360470_mobile-1.jpg" },
      { id: "pc-14", title: "Custom Design", type: "Custom", image: "https://cdn.crevado.com/artists/1062266/artwork/19361798_mobile-1.png" }
    ]
  }
];

export const testimonials = [
  {
    quote: "Christina onboarded fast and was productive from day one — rebranding a large volume of e-books and infographics, hitting tight deadlines, and consistently delivering high-quality, on-brand work that needed very little oversight. I would happily work with her again and highly recommend her to any team looking for a reliable, fast-moving designer.",
    author: "David McGuire",
    company: "Informa TechTarget"
  },
  {
    quote: "Christina is a skilled creative designer whose work consistently exceeded expectations. A collaborative team player who delivers high-quality work within tight deadlines — always with a professional and positive attitude.",
    author: "Faith Quinn",
    company: "Harte Hanks"
  },
  {
    quote: "Christina is professional and truly passionate about her work. I have worked with numerous graphic designers through the years and I can honestly say she made it so simple — her work is phenomenal.",
    author: "Tiffany Tsang Uffleman",
    company: "IPC Systems / FIA"
  },
  {
    quote: "A savvy designer with a great sense of what the client needs. She provides excellent, consistent design and production work for any media — and thinks outside the box while keeping complex, multi-version projects perfectly organized.",
    author: "Alla Pob",
    company: "Quadriga Art"
  },
  {
    quote: "A skilled, versatile and strong designer who follows creative direction extremely well — and just as often takes the lead herself. Organized, prompt, and a pleasure to work with. She was a huge asset to the workload I managed.",
    author: "Corinne Whitman",
    company: "Quadriga Art"
  },
  {
    quote: "Christina was an absolute pleasure to work with — she needed very little supervision and often took the reins, spearheading several projects simultaneously. I would not hesitate to have her on my team again.",
    author: "Crystal Caldona",
    company: "Quadriga Art"
  }
];

export const totals = {
  years: 20,
  clients: clients.length,
  projects: clients.reduce((acc, c) => acc + c.projects.length, 0),
  countries: 8
};
